export default [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "homeModule" */ '@views/home'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import(/* webpackChunkName: "homeIndex" */ '@views/home/homeIndex'),
        name: 'homeIndex',
        meta: {
          isLogin: false,
          isFooterShow: true,
      
          title : '首页-包拯'
        }
      },
      {
        path: '/chenzhen',
        component: () => import(/* webpackChunkName: "homeIndex" */ '@views/home/chenzhen'),
        name: 'chenzhen',
        meta: {
          isLogin: false,
          isFooterShow: false,
      
          title : '打开小程序'
        }
      },
      {
        path: '/homeActive',
        component: () => import(/* webpackChunkName: "homeActive" */ '@views/home/homeActive'),
        name: 'homeActiveIndex',
        meta: {
          isLogin: false,
          isFooterShow: false,
          keepAlive: true,
          title : '创意改样'
        }
      },
      {
        path: '/couponPage',
        component: () => import(/* webpackChunkName: "couponPage" */ '@views/home/couponPage'),
        name: 'couponPageIndex',
        meta: {
          isLogin: false,
          isFooterShow: false,
      
          title : '新人专享礼'
        }
      },
      {
        path: '/homeListNew',
        component: () => import(/* webpackChunkName: "homeListNew" */ '@views/home/homeListNew'),
        name: 'homeListNew',
        meta: {
          isLogin: true,
          isFooterShow: true,
          keepAlive: false,
          title : '服务列表'
          
        }
      },
      {
        path: '/serviceDetail',
        component: () => import(/* webpackChunkName: "serviceDetail" */ '@views/home/serviceDetail/index'),
        name: 'serviceDetail',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '服务详情'
        }
      },
      {
        path: '/about',
        component: () => import(/* webpackChunkName: "about" */ '@views/home/about/index'),
        name: 'about',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '关于我们'
        }
      },
      {
        path: '/agreement',
        component: () => import(/* webpackChunkName: "homeIndex" */ '@views/home/agreement/index'),
        name: 'agreement',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '用户协议'
        }
      },
      {
        path: '/agreement/agreementStyle',
        component: () => import(/* webpackChunkName: "homeIndex" */ '@views/home/agreement/agreementStyle'),
        name: 'agreementStyle',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '改样服务协议'
        }
      },
      {
        path: '/doc',
        component: () => import(/* webpackChunkName: "homeIndex" */ '@views/home/doc/index'),
        name: 'agreementDoc',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '用户协议'
        }
      },
      {
        path: '/scope',
        component: () => import(/* webpackChunkName: "scope" */ '@views/home/scope/index'),
        name: 'scope',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '快递说明'
        }
      },
      {
        path: '/feeScale',
        component: () => import(/* webpackChunkName: "feeScale" */ '@views/home/feeScale/index'),
        name: 'feeScale',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '收费标准'
        }
      },
      {
        path: '/quick',
        component: () => import(/* webpackChunkName: "quick" */ '@views/home/quick/index'),
        name: 'quick',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '快速预约'
        }
      },
      {
        path: '/adrInfo',
        component: () => import(/* webpackChunkName: "adrInfo" */ '@views/home/adrInfo/index'),
        name: 'adrInfo',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '快速预约'
        }
      },
      {
        path: '/homeBag',
        component: () => import(/* webpackChunkName: "homeBag" */ '@views/home/homeBag/index'),
        name: 'homeBag',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '方案'
        }
      },
      {
        path: '/teamDetail',
        component: () => import(/* webpackChunkName: "teamDetail" */ '@views/home/teamDetail/index'),
        name: 'teamDetail',
        meta: {
          isLogin: false,
          isFooterShow: false,
          keepAlive: false,
          title : '邀请好友拼团'
        }
      },
      {
        path: '/metalFilm',
        component: () => import(/* webpackChunkName: "teamDetail" */ '@views/home/metalFilm/index'),
        name: 'metalFilm',
        meta: {
          isLogin: false,
          isFooterShow: false,
          keepAlive: false,
          title : '五金贴膜'
        }
      },
      {
        path: '/getGrowthShare',
        component: () => import(/* webpackChunkName: "teamDetail" */ '@views/home/getGrowthShare/index'),
        name: 'getGrowthShare',
        meta: {
          isLogin: false,
          isFooterShow: false,
          keepAlive: false,
          title : ''
        }
      },
      {
        path: '/getGrowthShareDetail',
        component: () => import(/* webpackChunkName: "teamDetail" */ '@views/home/getGrowthShare/growthShare'),
        name: 'getGrowthShareDetail',
        meta: {
          isLogin: false,
          isFooterShow: false,
          keepAlive: false,
          title : ''
        }
      },
      {
        path: '/configShare',
        component: () => import(/* webpackChunkName: "homeIndex" */ '@views/home/configShare'),
        name: 'configShareIndex',
        meta: {
          isLogin: false,
          isFooterShow: false,
      
          title : '分享配置'
        }
      },
      {
        path: '/bagGame',
        component: () => import(/* webpackChunkName: "homeIndex" */ '@views/home/bagGame'),
        name: 'bagGameIndex',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '拼包包小游戏'
        }
      },
    ]
  }
]
